import { h } from "preact";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";

import { JUSTIKA_ICON } from "utils/constants";

import Img from "components/Img";
import P from "components/P";

import CheckIcon from "../images/check-icon.svg";
import messages from "../messages";

const AdvantageItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Container = styled.div`
  flex: 55;
  padding: 26px 26px 26px 38px;
  background-color: white;
  display: flex;
  justify-content: center;
`;

const Subtitle = styled.div`
  font-family: Montserrat;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  margin-top: 18px;
  margin-bottom: 18px;
  max-width: 360px;
`;

const Title = styled.div`
  color: #333333;
  font-family: Montserrat;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: 0em;
  text-align: left;
  max-width: 372px;
  margin-top: 16px;
`;

function getTitleText(props) {
  const cohort = props.matches.cohort;
  switch (cohort) {
    case 'aligator':
    case 'badak':
    case 'cheetah':
      return 'Konsultasi Hukum Online dengan Advokat Pilihan';
    case 'dino':
      return 'Butuh Saran Hukum Cepat dan Terpercaya?';
    default:
      return 'Konsultasi Hukum Online dengan Advokat Pilihan';
  }
}

function getSubtitleText(props) {
  const cohort = props.matches.cohort;
  switch (cohort) {
    case 'aligator':
    case 'badak':
    case 'cheetah':
      return '15.000+ masalah hukum telah dikonsultasikan bersama kami';
    case 'dino':
      return 'Gunakan konsultasi online yang dipercaya +15.000 pengguna';
    default:
      return '15.000+ masalah hukum telah dikonsultasikan bersama kami';
  }
}

function getAdvantageOne(props) {
  const cohort = props.matches.cohort;
  switch (cohort) {
    case 'aligator':
    case 'badak':
    case 'cheetah':
      return 'Diskusi dengan advokat tanpa keluar rumah';
    case 'dino':
      return 'Tanya langsung advokat tanpa keluar rumah';
    default:
      return 'Diskusi dengan advokat tanpa keluar rumah';
  }
}

function getAdvantageTwo(props) {
  const cohort = props.matches.cohort;
  switch (cohort) {
    case 'aligator':
    case 'badak':
    case 'cheetah':
      return 'Menerima segala bidang masalah hukum';
    case 'dino':
      return 'Cocok bagi anda yang awam hukum';
    default:
      return 'Menerima segala bidang masalah hukum';
  }
}

const AdvantageItem = (props) => {
  return (
    <AdvantageItemContainer>
      <Img
        src={CheckIcon}
        alt="Check Icon"
        style={{ height: "20px", width: "20px" }}
      />
      <P>{props.children}</P>
    </AdvantageItemContainer>
  );
};

const LeftSection = (props) => {
  const cohort = props.matches.cohort
  return (
    <Container>
      <div>
        {cohort == 'cheetah' ?
          null
          :
          <Img
            alt="Justika Icon"
            src={JUSTIKA_ICON}
            style={{ height: "20px", width: "auto" }}
          />
        }
        <Title id="title">
          {getTitleText(props)}
        </Title>
        <Subtitle id="subtitle">
          {getSubtitleText(props)}
        </Subtitle>
        <AdvantageItem id="adv-1">
          {getAdvantageOne(props)}
        </AdvantageItem>
        <AdvantageItem id="adv-2">
          {getAdvantageTwo(props)}
        </AdvantageItem>
      </div>
    </Container>
  );
};

export default LeftSection;
